// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  //  apiUrl: 'https://10.100.1.30:5001/api',
  
  //apiUrl: 'https://192.168.100.109:5001/api',
  //apiUrl: 'https://poolwatertest.avient.se/api',
  apiUrl: 'https://poolwaterapi.addsafety.se/api', 
  production: false,
  defaultCacheTime: 60000,
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
